import ChildSeatIcon from '@/assets/icons/child-seat.svg'
import CoupleIcon from '@/assets/icons/couple-icon.svg'
import SuitcaseIcon from '@/assets/icons/suitcase.svg'
import TaxiIcon from '@/assets/icons/taxi.svg'
import TripDates from '@/assets/illustrations/trip-dates.svg'
import { useOrderSummaryStore } from '../../store'

export const LocationInfo = () => {
  const {
    fromPointName,
    toPointName,
    fromPointDetails,
    toPointDetails,
    handLuggage,
    checkedLuggage,
    vehicleSizeName,
    passengers,
    childSeats,
    booster,
    carrier,
  } = useOrderSummaryStore()

  const childrenSeats = (childSeats || 0) + (booster || 0) + (carrier || 0)

  if (!fromPointName && !toPointName) {
    return null
  }
  return (
    <div className='relative my-4'>
      <div className='flex w-full items-stretch gap-2'>
        <span className='h-full'>
          <TripDates className='h-full' />
        </span>
        <div className='flex w-full flex-col gap-6'>
          <div>
            <p className='text-grey-60 font-medium'>{fromPointName}</p>
            <p className='text-grey-50 text-sm'>{fromPointDetails}</p>
          </div>
          <div>
            <p className='text-grey-60 font-medium'>
              {toPointName || <>&nbsp;</>}
            </p>
            <p className='text-grey-50 text-sm'>
              {toPointDetails || <>&nbsp;</>}
            </p>
          </div>
        </div>
      </div>
      <ul className='my-3 flex w-full items-center justify-center gap-2 min-[28rem]:gap-6 md:gap-2 lg:gap-4 xl:gap-6'>
        <li className='flex items-center gap-2 text-xs capitalize @[14rem]:text-base'>
          <TaxiIcon className='h-full scale-70' />
          {vehicleSizeName}
        </li>
        <li className='flex items-center gap-2 text-xs capitalize @[14rem]:text-base'>
          <SuitcaseIcon className='h-full scale-70' />
          {checkedLuggage + handLuggage}
        </li>
        <li className='flex items-center gap-2 text-xs capitalize @[14rem]:text-base'>
          <CoupleIcon className='h-full scale-70' /> {passengers}
        </li>
        {childrenSeats ? (
          <li className='flex items-center gap-2 text-xs capitalize @[14rem]:text-base'>
            <ChildSeatIcon className='h-4 w-4 @[14rem]:h-6 @[14rem]:w-6' />{' '}
            {childrenSeats}
          </li>
        ) : null}
      </ul>
    </div>
  )
}
